module.exports = __webpack_public_path__ + "media/images/icon-coupon@3x-2648eecbc0ca753a4ca5ac885788da19.png";